const background_path = 'https://image.tmdb.org/t/p/original/'

export const ApiBackground = background_path